import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=5ef65c8a&"
import script from "./forms.js?vue&type=script&lang=js&"
export * from "./forms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports